import { useIntl } from 'react-intl';

import { TextDocument } from '@sorare/core/src/routing/TextDocument/lazy';

import { InfoLayout } from '#src/components/layouts/InfoLayout.tsx';

const PrivacyPolicy = () => {
  const { formatMessage } = useIntl();
  return (
    <InfoLayout>
      <TextDocument
        document={formatMessage({
          id: 'PrivacyPolicy.path',
          defaultMessage: 'PRIVACY_POLICY.md',
        })}
        escapeHtml={false}
      />
    </InfoLayout>
  );
};

export default PrivacyPolicy;
